import React from 'react';
import { Card, CardContent } from '../../components/ui/card';
import { ExternalLink } from 'lucide-react';

const UniversityLodgeSchemePage = () => {
  return (
    <div className="p-6 md:p-12 lg:p-16" data-testid="university-lodge-scheme-page">
      <div className="max-w-4xl">
        <h1 className="font-heading text-4xl md:text-5xl font-bold text-gray-900 mb-6">
          University Lodge Scheme
        </h1>

        {/* Introduction */}
        <section className="mb-10" data-testid="scheme-intro">
          <p className="text-lg text-gray-700 leading-relaxed mb-6">
            The Scottish University Lodge Scheme was created by the Grand Master Mason; initially for 
            a five-year pilot period. The scheme is managed by the Grand Lodge of Scotland. St David 
            (University Lodge) was the pilot lodge; Lodge St Andrew in St Andrews, and Lodge St Nicholas 
            in Aberdeen have since joined the scheme, and Lodge Glasgow Kilwinning in Glasgow.
          </p>
        </section>

        {/* Benefits */}
        <section className="mb-10" data-testid="scheme-benefits">
          <Card className="border-gray-100 bg-gradient-to-br from-emerald-50/30 to-white">
            <CardContent className="p-6 md:p-8">
              <h2 className="font-heading text-2xl font-semibold text-gray-900 mb-4">Scheme Benefits</h2>
              <p className="text-lg text-gray-700 leading-relaxed">
                The scheme provides dispensations for the Lodge to accept applications from those who do 
                not meet the normal age or residency requirements and to reduce fees by 50% for those 
                applicants in full-time higher education, thereby making it easier for undergraduates 
                and graduates to enter Freemasonry whilst away from home studying.
              </p>
            </CardContent>
          </Card>
        </section>

        {/* English Connection */}
        <section className="mb-10" data-testid="english-scheme">
          <p className="text-lg text-gray-700 leading-relaxed mb-4">
            England has a similar, very successful, scheme run by the United Grand Lodge of England, 
            which now includes more than 65 lodges. The Scottish University Lodge Scheme organizers 
            have worked closely with their English counterparts, consequently forging very close links 
            between them.
          </p>
          <a
            href="http://www.universitiesscheme.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-emerald-600 hover:text-emerald-700 font-medium transition-colors"
            data-testid="english-scheme-link"
          >
            Visit the English Universities Scheme
            <ExternalLink className="h-4 w-4" />
          </a>
        </section>

        {/* Member Lodges */}
        <section data-testid="member-lodges">
          <h2 className="font-heading text-2xl font-semibold text-gray-900 mb-4">Scheme Member Lodges</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Card className="border-gray-100 hover:shadow-md transition-shadow">
              <CardContent className="p-4">
                <h3 className="font-medium text-gray-900">St David (University Lodge) No. 36</h3>
                <p className="text-sm text-gray-500">Edinburgh - Pilot Lodge</p>
              </CardContent>
            </Card>
            <Card className="border-gray-100 hover:shadow-md transition-shadow">
              <CardContent className="p-4">
                <h3 className="font-medium text-gray-900">Lodge St Andrew</h3>
                <p className="text-sm text-gray-500">St Andrews</p>
              </CardContent>
            </Card>
            <Card className="border-gray-100 hover:shadow-md transition-shadow">
              <CardContent className="p-4">
                <h3 className="font-medium text-gray-900">Lodge St Nicholas</h3>
                <p className="text-sm text-gray-500">Aberdeen</p>
              </CardContent>
            </Card>
            <Card className="border-gray-100 hover:shadow-md transition-shadow">
              <CardContent className="p-4">
                <h3 className="font-medium text-gray-900">Lodge Glasgow Kilwinning</h3>
                <p className="text-sm text-gray-500">Glasgow</p>
              </CardContent>
            </Card>
          </div>
        </section>
      </div>
    </div>
  );
};

export default UniversityLodgeSchemePage;
